import { useTranslation } from "react-i18next";
import ContainerLayout from "../../../components/container-layout/ContainerLayout";
import StateComponents from "../../../components/state-component/StateComponents";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import StepperCustom from "../../../components/step/Stepper";
import { useEffect, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { ButtonContained } from "../../../components/button/ButtonCustoms";
import ContainerButton from "../../../components/button/ContainerButton";
import { EvidencePayment, FileApplicant, FormApplicant, TermPayment } from "../list-applicants/applicent-detail";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AdmissionFrontApi } from "../../../api/admission-front/admission-front.api";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";

export default function StudentRegistrationDetail() {
  const { t } = useTranslation();
  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const [tabStep, setTebStep] = useState(0);
  const [form, setForm] = useState<any>();

  const allStep = [
    {
      name: t("STUDENT_REGISTRATION_APPLICANT_PERSONAL_INFO"),
      isAccept: false,
      icon: null
    },
    {
      name: t("STUDENT_REGISTRATION_APPLICATION_PAYMENT_PROOF"),
      isAccept: false,
      icon: null
    },
    {
      name: t("STUDENT_REGISTRATION_TUITION_PAYMENT_PROOF"),
      isAccept: false,
      icon: null
    },

  ];
  const getDetail = async () => {
    dispatch(setLoading());

    await AdmissionFrontApi.findOne(id).then((res) => {
      if (res.status < 300) {
        setForm(res.data.data)
      }
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      dispatch(unsetLoading());
    })
  }

  useEffect(() => {
    getDetail()
  }, [])
  return (
    <div className='w-full'>
      <ContainerLayout
        title={t("STUDENT_REGISTRATION_APPLICANT_PERSONAL_INFO")}
        // hidden_sub_title
        navigateContent={
          <NavigateListCustom
            navigateData={[
              {
                key: "complaintSubmit",
                name: t("STUDENT_REGISTRATION"),
                disabled_match: true,
                pathName: routeName.admission.list_applicants
              },

              {
                key: "complaintSubmit",
                name: t("STUDENT_REGISTRATION_APPLICANT_PERSONAL_INFO"),
                pathName: routeName.admission.list_applicants
              },
            ]}
          />
        }
        buttonContent={
          // <ContainerButton
          //     justifyContent='flex-end'
          //     buttonData={[
          //         {
          //             buttonProps: {
          //                 onClick: handleDownloadReport
          //             },
          //             key: "DOWNLOAD_CSV",
          //             label: t("COMPLAINTS_DOWNLOAD_CSV"),
          //             seq: 1,
          //             type: "DOWNLOAD_CSV"
          //         }
          //     ]}
          // />
          <></>
        }
        content={
          <div className='w-full'>
            <section
              style={{
                display: "flex",
                justifyContent: "start",
                marginTop: "24px",
              }}
            >
              <StepperCustom
                step={tabStep}
                setStep={setTebStep}
                stepLabel={allStep}
                view={true}
              />
            </section>
            {tabStep === 0 &&
              <div style={{ display: 'flex', flexDirection: 'column', gap: "20px" }}>
                <FormApplicant form={form} />
                <FileApplicant form={form} />

              </div>
            }
            {tabStep === 1 &&
              <>
                <EvidencePayment form={form} />
              </>
            }
            {tabStep === 2 &&
              <>
                <TermPayment form={form} />
              </>
            }
            <ContainerButton
              sxContainer={{ my: 3 }}
              buttonData={[
                {
                  seq: 1,
                  buttonProps: {
                    onClick: () => {
                      navigate(-1)
                     },
                  },
                  key: "CANCEL",
                  label: t("STUDENT_REGISTRATION_BACK"),
                  type: "CANCEL"
                },

              ]}
            />
          </div>
        }
      />

    </div>
  )
}


